import {
  Box,
  Button,
  Chip,
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { rem } from "assets/js/common";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";

import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
  couponRegist: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "calc(100vh - 111px)",
    "& .coupon-info": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: rem(30),
      "& .count": {
        display: "flex",
        alignItems: "center",
        fontWeight: 700,
        "& span": {
          fontSize: rem(24),
          fontWeight: 800,
          padding: "0 3px 0 7px",
          lineHeight: rem(30),
        },
      },
    },
    "& .coupon-list": {
      padding: `${rem(30)} ${rem(30)} ${rem(40)}`,
      "& .fontN": {
        fontWeight: "400",
        lineHeight: rem(18),
        "& .MuiSvgIcon-root": {
          display: "none",
        },
        "&.MuiButton-text": {
          fontSize: rem(13),
        },
        "&:after": {
          content: "''",
          width: rem(18),
          height: rem(18),
          backgroundImage: `url(${process.env.PUBLIC_URL
            }/images/icon/arrow-selectbox.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
    },
    "& .coupon-list + .club-list": {
      paddingTop: rem(10),
    },
    "& .regist-form": {
      padding: "50px 30px",
      "& button": {
        marginTop: rem(10),
      },
    },
    "& .border-top": {
      borderTop: "1px solid #eee",
    },
  },
}));

export default function RegistCoupon() {
  const classes = useStyles();
  const history = useHistory();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [couponImg, setCouponImg] = useState("");
  const [fetching, setFetching] = useState(false);
  const [totalCnt, setTotalCnt] = useState("");
  const [myCouponList, setMyCouponList] = useState([]);
  const [clubCouponList, setClubCouponList] = useState([]);
  const [sordFld, setSordFld] = useState("dday");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState("dday");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    return new Promise((resolve) => {
      setFetching(true);
      loadCouponImg();
      loadList();
      resolve(true);
    });
  };

  const loadCouponImg = () => {
    setFetching(true);
    axios
      .get("/api/cp/coupon-image/get")
      .then((res) => {
        setCouponImg(res.data.data.couponImage.imgUrl);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  window.appBackKeyHandle = () => {
    if (drawerOpen) {
      setDrawerOpen(false);
    } else {
      history.goBack();
    }
  };

  const loadList = (item) => {
    setFetching(true);
    axios
      .get("/api/cp/coupon/my-list", {
        params: {
          schTp: favInfo ? favInfo.visibleTp : "1",
          storeCode: storeCode,
          sordFld: item ? item : sordFld,
          schStat: "usable"
        },
      })
      .then((res) => {

        setTotalCnt(res.data.data.totalCnt);
        setMyCouponList(res.data.data.myCouponList);
        setClubCouponList(res.data.data.clubCouponList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  useEffect(() => {
    if (drawerOpen === true) setDrawerData(sordFld);
  }, [drawerOpen]);

  return (
    <>
      <Loading open={fetching ? true : false} />
      <PullToRefresh
        onRefresh={fetchData}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className={"bg-grey nopad " + classes.couponRegist}>
          <div className="coupon-info bg-white">
            <div className="h2 weight800">보유 쿠폰</div>
            <div className="count">
              총 <span>{totalCnt}</span>장
            </div>
          </div>
          {myCouponList.length > 0 && (
            <div className="coupon-list bg-grey">
              <Box
                display="flex"
                justifyContent="flex-end"
                style={{ marginBottom: rem(12) }}
              >
                <Button
                  onClick={() => {
                    setDrawerOpen(true);
                  }}
                  className="fontN"
                >
                  {sordFld == "dday" ? "만료임박순" : "발급일순"}
                  <KeyboardArrowDownTwoToneIcon />
                </Button>
              </Box>
              <ul>
                {myCouponList.map((item, i) => {

                  const isBetween = moment().format("YY.MM.DD") >= moment(item.startDate).format("YY.MM.DD") && moment().format("YY.MM.DD") <= moment(item.endDate).format("YY.MM.DD");
                  console.log(isBetween);
                  return isBetween ? (
                    <li key={i} className="coupon-item">
                      <div
                        className="item-wrap"
                        onClick={() => {
                          history.push({
                            pathname: "/coupon/detail",
                            props: {
                              promotionSubId: item.promotionSubId,
                              couponCode: item.couponCode,
                              // storeCode: item.storeCode,
                              // promotionSubId: "2918821",
                              // couponCode: "13522384",
                              storeCode: storeCode,
                            },
                          });
                        }}
                      >
                        <div className="contents">
                          <div>
                            <div className="chip-area">
                              <Chip
                                label={`D-${item.dday}`}
                                color="primary"
                                className="dday"
                                size="small"
                              />
                              {item.autoYn == "Y" && (
                                <Chip
                                  label="자동적용"
                                  variant="outlined"
                                  className="autoApp"
                                  size="small"
                                />
                              )}
                            </div>
                            <p className="tit">{item.title1}</p>
                            <p className="tit-sub">{item.couponNm}</p>
                          </div>

                          <p className="date">
                            {moment(item.startDate).format("YY.MM.DD")}~{moment(item.endDate).format("YY.MM.DD")}
                          </p>
                        </div>

                        {item.autoYn != "Y" && (
                          <>
                            <div className="side">
                              <Button>
                                <img
                                  src={`${process.env.PUBLIC_URL
                                    }/images/icon/barcode.svg`}
                                  style={{ width: "27px", height: "15px" }}
                                />
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    </li>
                  ) : (
                    <li key={i} className="coupon-item" style={{ backgroundColor: 'lightgray' }}>
                      <div
                        className="item-wrap"

                      >
                        <div className="contents">
                          <div>

                            <p className="tit">{item.title1}</p>
                            <p className="tit-sub">{item.couponNm}</p>
                          </div>
                          <p className="date">
                            {moment(item.startDate).format("YY.MM.DD")}~{moment(item.endDate).format("YY.MM.DD")}
                          </p>
                          <p className="date">
                            사용할 수 있는 기간이 아닙니다
                          </p>
                        </div>


                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}
          {clubCouponList.length > 0 && (
            <div className="coupon-list bg-grey club-list">
              {myCouponList.length == 0 && (
                <Box display="flex" justifyContent="flex-end" mb={3}>
                  <Button
                    onClick={() => {
                      setDrawerOpen(true);
                    }}
                  >
                    {sordFld == "dday" ? "만료임박순" : "발급일순"}
                    <KeyboardArrowDownTwoToneIcon />
                  </Button>
                </Box>
              )}
              <Box mb={3}>
                <h2 className="h2 weight800">클럽 쿠폰</h2>
              </Box>
              <ul>
                {clubCouponList.map((item, i) => {
                  const isBetween = moment().format("YY.MM.DD") >= moment(item.startDate).format("YY.MM.DD") && moment().format("YY.MM.DD") <= moment(item.endDate).format("YY.MM.DD");
                  return isBetween ? (
                    <li key={i} className="coupon-item">
                      <div
                        className="item-wrap"
                        onClick={() => {
                          history.push({
                            pathname: `/coupon/detail`,
                            props: {
                              promotionSubId: item.promotionSubId,
                              couponCode: item.couponCode,
                              //   storeCode: item.storeCode,
                              // promotionSubId: "2918821",
                              // couponCode: "13522384",
                              storeCode: storeCode,
                            },
                          });
                        }}
                      >
                        <div className="contents">
                          <div>
                            <div className="chip-area">
                              <Chip
                                label={`D-${item.dday}`}
                                color="primary"
                                className="dday"
                                size="small"
                              />
                              {item.autoYn == "Y" && (
                                <Chip
                                  label="자동적용"
                                  variant="outlined"
                                  size="small"
                                />
                              )}
                            </div>
                            <p className="tit">{item.title1}</p>
                            <p className="tit-sub">{item.couponNm}</p>
                          </div>

                          <p className="date">
                            {moment(item.startDate).format("YY.MM.DD")}~{moment(item.endDate).format("YY.MM.DD")}
                          </p>
                        </div>

                        {item.autoYn != "Y" && (
                          <>
                            <hr className="divider" />

                            <div className="side">
                              <Button>
                                <img
                                  src={`${process.env.PUBLIC_URL
                                    }/images/icon/barcode.svg`}
                                  style={{ width: "27px", height: "15px" }}
                                />
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    </li>
                  ) : (<li key={i} className="coupon-item">
                    <div
                      className="item-wrap"

                    >
                      <div className="contents">
                        <div>

                          <p className="tit">{item.title1}</p>
                          <p className="tit-sub">{item.couponNm}</p>
                        </div>

                        <p className="date">
                          {moment(item.startDate).format("YY.MM.DD")}~{moment(item.endDate).format("YY.MM.DD")}
                        </p>
                        <p className="date">
                          사용할 수 있는 기간이 아닙니다
                        </p>
                      </div>


                    </div>
                  </li>)
                })}
              </ul>
            </div>
          )}
          {myCouponList.length == 0 && clubCouponList.length == 0 && (
            <>
              <div className="nodata" style={{ margin: `${rem(200)} 0 0` }}>
                <Box className="illust">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                  />
                </Box>
                <p className="color-info">조회된 내역이 없습니다</p>
              </div>
            </>
          )}
          <Box className="notice is-bottom bg-grey border-top">
            <p className="title">
              <i className="ico-noti" />
              유의사항
            </p>
            <ul className="list list-dot color-info font-14">
              <li>유효기간이 지난 쿠폰은 재지급 되지 않습니다.</li>
              <li>이미 사용했거나 유효기간이 지난 쿠폰은
                ’
                사용내역
                ’
                탭에서 확인 가능합니다.</li>
              <li>자동쿠폰은 APP 바코드 적립시에만 자동으로 적용됩니다.</li>
              <li>수동쿠폰은 매장에서 직접 스캐닝하여
                사용해야 합니다.</li>

            </ul>
          </Box>

          {/* ST : Drawer-row */}
          <Drawer
            anchor="bottom"
            open={drawerOpen}
            onClose={() => {
              setDrawerOpen(false);
            }}
            className="drawer-common-bottom size-small"
          >
            <div className="drawer-head">
              <h3>정렬 기준</h3>
              <IconButton
                aria-label="close"
                className="btn-close"
                onClick={() => {
                  setDrawerOpen(false);
                }}
              >
                <span className="hidden">닫기</span>
              </IconButton>
            </div>

            <div className="drawer-body">
              <Box className="box-type-1">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={drawerData}
                  value={drawerData}
                  name="radio-buttons-group"
                  onChange={(e) => {
                    setDrawerData(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="dday"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                        className="mgR15"
                      />
                    }
                    label="만료임박순"
                  />
                  <FormControlLabel
                    value="pday"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                        className="mgR15"
                      />
                    }
                    label="발급일순"
                  />
                </RadioGroup>
              </Box>
            </div>
            <div className="drawer-foot">
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  setSordFld(drawerData);
                  loadList(drawerData);
                  setDrawerOpen(false);
                }}
              >
                선택완료
              </Button>
            </div>
          </Drawer>
          {/* EN : Drawer-row */}
        </div>
      </PullToRefresh>
    </>
  );
}
